module.exports = __webpack_public_path__ + "static/jihlava-1093de0fc85a8a71af0d202a17d6d668.svg";